import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { color = "#2E3092", height = 27, width = 31 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 27 31"
      fill="none"
    >
      <path
        d="M4.72583 3.31574C4.72583 1.67544 6.05556 0.345703 7.69587 0.345703H17.7197L27.0011 9.62707V27.076C27.0011 28.7164 25.6714 30.0461 24.0311 30.0461H7.69587C6.05556 30.0461 4.72583 28.7164 4.72583 27.076V3.31574Z"
        fill="url(#paint0_linear_251_23944)"
      />
      <path
        d="M17.7205 0.345703L27.0017 9.62695V27.0762C27.0016 28.7163 25.6721 30.0457 24.032 30.0459H7.69604C6.05592 30.0457 4.72639 28.7163 4.72632 27.0762V3.31543C4.72649 1.67537 6.05599 0.345871 7.69604 0.345703H17.7205ZM7.69604 1.45898C6.6711 1.45915 5.83977 2.29048 5.8396 3.31543V27.0762C5.83967 28.1012 6.67104 28.9324 7.69604 28.9326H24.032C25.0569 28.9324 25.8874 28.1012 25.8875 27.0762V10.5537H19.5759C18.0384 10.5536 16.7919 9.30706 16.7917 7.76953V1.45898H7.69604ZM17.906 7.76953C17.9062 8.69194 18.6535 9.4393 19.5759 9.43945H25.238L17.906 2.10645V7.76953Z"
        fill="#DADFE3"
      />
      <rect
        y="14.3457"
        width="22.2753"
        height="11.1376"
        rx="2"
        fill={color}
      />
      <path
        d="M8.624 19.144C8.624 19.4427 8.552 19.7227 8.408 19.984C8.26933 20.2453 8.048 20.456 7.744 20.616C7.44533 20.776 7.06667 20.856 6.608 20.856H5.672V23H4.552V17.416H6.608C7.04 17.416 7.408 17.4907 7.712 17.64C8.016 17.7893 8.24267 17.9947 8.392 18.256C8.54667 18.5173 8.624 18.8133 8.624 19.144ZM6.56 19.952C6.86933 19.952 7.09867 19.8827 7.248 19.744C7.39733 19.6 7.472 19.4 7.472 19.144C7.472 18.6 7.168 18.328 6.56 18.328H5.672V19.952H6.56ZM11.3712 17.416C11.9579 17.416 12.4725 17.5307 12.9152 17.76C13.3632 17.9893 13.7072 18.3173 13.9472 18.744C14.1925 19.1653 14.3152 19.656 14.3152 20.216C14.3152 20.776 14.1925 21.2667 13.9472 21.688C13.7072 22.104 13.3632 22.4267 12.9152 22.656C12.4725 22.8853 11.9579 23 11.3712 23H9.41919V17.416H11.3712ZM11.3312 22.048C11.9179 22.048 12.3712 21.888 12.6912 21.568C13.0112 21.248 13.1712 20.7973 13.1712 20.216C13.1712 19.6347 13.0112 19.1813 12.6912 18.856C12.3712 18.5253 11.9179 18.36 11.3312 18.36H10.5392V22.048H11.3312ZM18.6016 17.416V18.32H16.2736V19.752H18.0576V20.64H16.2736V23H15.1536V17.416H18.6016Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_251_23944"
          x1="15.8635"
          y1="30.0461"
          x2="15.8635"
          y2="0.345703"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F2F4" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgComponent;
